var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 112 120",
    fill: "#F4521B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.905 45.0976C75.6 41.9022 74.5303 38.8273 72.7864 36.1325C71.0424 33.4378 68.6753 31.2024 65.8853 29.6154C63.0952 28.0283 59.9641 27.1362 56.7565 27.0144C53.549 26.8926 50.3593 27.5447 47.4569 28.9156C44.5545 30.2865 42.0248 32.3359 40.0814 34.8907C38.1381 37.4454 36.8383 40.4304 36.2919 43.5934C35.7455 46.7564 35.9685 50.0045 36.942 53.0631C37.9156 56.1218 39.6111 58.9012 41.8853 61.1664L54.3545 73.6591C54.5732 73.8796 54.8334 74.0546 55.1201 74.174C55.4068 74.2935 55.7143 74.355 56.0249 74.355C56.3355 74.355 56.643 74.2935 56.9297 74.174C57.2164 74.0546 57.4766 73.8796 57.6953 73.6591L70.1174 61.1664C72.2142 59.0853 73.8213 56.5637 74.8224 53.7843C75.8235 51.0049 76.1933 48.0376 75.905 45.0976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.aefa901a9317c042d7419cff56d16921.svg";
export { ForwardRef as ReactComponent };